import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dimensions-source',
  templateUrl: './dimensions-source.component.html',
  styleUrls: ['./dimensions-source.component.scss']
})
export class DimensionsSourceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
